import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { useIntl } from '@grandvisionhq/state';
import { getAttrValue, isString, sanitizeStringForUrl, getLocalizedAttrValue } from '@grandvisionhq/utils';
import * as React from 'react';
import { getProductTypeName } from '../../helpers.js';

// eslint-disable-next-line simple-import-sort/imports
const useBrandLink = (product)=>{
    var ref1;
    const { locale  } = useIntl();
    if (typeof window === 'undefined') {
        return '';
    }
    const link = React.useMemo(()=>{
        var ref;
        const productType = getProductTypeName(product);
        const brand = getAttrValue(product.masterVariant, 'brand');
        if (!isString(brand) || brand === '') return '';
        const sanitizedBrand = sanitizeStringForUrl(brand);
        const path = ((ref = window.location) === null || ref === void 0 ? void 0 : ref.pathname) || '';
        const parts = path.split('/').filter((v)=>v !== ''
        );
        const isMultilingual = /[[a-z]{2}_[A-Z]{2}/g.test(parts[0]);
        const category = isMultilingual ? parts[1] : parts[0];
        const subCategory = isMultilingual ? parts[2] : parts[1];
        const baseUrl = `/${isMultilingual ? `${parts[0]}/` : ''}${category}`;
        if (productType && CommerceToolsApi.isLenses(productType)) {
            const replacementFrequency = getLocalizedAttrValue(product.masterVariant, 'replacementFrequency', locale) || '';
            return `${baseUrl}/${encodeURIComponent(sanitizeStringForUrl(replacementFrequency))}/${encodeURIComponent(sanitizedBrand)}`;
        }
        if (productType && CommerceToolsApi.isSolutions(productType)) {
            const contactLensCareType = product && getLocalizedAttrValue(product.masterVariant, 'contactLensCareType', locale) || '';
            return `${baseUrl}/${encodeURIComponent(sanitizeStringForUrl(contactLensCareType))}/${encodeURIComponent(sanitizedBrand)}`;
        }
        if (productType && CommerceToolsApi.isReadyReaders(productType)) {
            return `${baseUrl}/${subCategory}/${encodeURIComponent(sanitizedBrand)}`;
        }
        if (productType && CommerceToolsApi.isAccessories(productType)) {
            const accessoryType = getLocalizedAttrValue(product.masterVariant, 'accessoryType', locale) || '';
            return `${baseUrl}/${encodeURIComponent(sanitizeStringForUrl(accessoryType))}/${encodeURIComponent(sanitizedBrand)}`;
        }
        return `${baseUrl}/${encodeURIComponent(sanitizedBrand)}`;
    }, [
        (ref1 = window.location) === null || ref1 === void 0 ? void 0 : ref1.pathname,
        product
    ]);
    return link;
};

export { useBrandLink };
//# sourceMappingURL=use-brand-link.js.map
